export default "__VITE_ASSET__Crzm0c5o__"